import type { Photo } from '../types/contract';

export interface DateRangeFilter {
  start: string;
  end: string;
}

const getFilterDate = (photo: Photo) => photo.capturedAt ?? photo.createdAt;

const parseDateBoundary = (value: string, boundary: 'start' | 'end') => {
  if (!value) return null;

  const suffix = boundary === 'start' ? 'T00:00:00.000' : 'T23:59:59.999';
  const date = new Date(`${value}${suffix}`);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const isPhotoInDateRange = (photo: Photo, range: DateRangeFilter) => {
  const sourceDate = getFilterDate(photo);
  if (!sourceDate) return false;

  const photoDate = new Date(sourceDate);
  if (Number.isNaN(photoDate.getTime())) return false;

  const start = parseDateBoundary(range.start, 'start');
  const end = parseDateBoundary(range.end, 'end');

  if (start && photoDate < start) return false;
  if (end && photoDate > end) return false;

  return true;
};
